import { stringify } from 'qs';
import request from '@/utils/request';
import { loginOrg, loginUser, loginCompany } from '@/utils/LoginContext';
export async function query(params) {
  return request(`/iwms-wms/wms/alcntc/page`, {
    method: 'POST',
    body: params,
  });
}

/**
 * 不分页
 * @param params
 * @returns {Promise<{error: string}|*|{error: string}|{error: string}>}
 */
export async function queryWaveAlcNtcBills(params) {
  return request(`/iwms-wms/wms/alcntc/queryWaveAlcNtcBill`, {
    method: 'POST',
    body: params,
  });
}

export async function add(params) {
  return request(`/iwms-wms/wms/alcntc`, {
    method: 'POST',
    body: params,
  });
}

export async function saveAndAudit(params) {
  return request(`/iwms-wms/wms/alcntc/saveAndAudit`, {
    method: 'POST',
    body: params,
  });
}

export async function update(params) {
  return request(`/iwms-wms/wms/alcntc/modify`, {
    method: 'POST',
    body: params,
  });
}

export async function get(param) {
  return request(`/iwms-wms/wms/alcntc/${param.uuid}`);
}

export async function remove(payload) {
  return request(`/iwms-wms/wms/alcntc/${payload.uuid}?version=${payload.version}`, {
    method: 'DELETE'
  });
}

export async function audit(payload) {
  return request(`/iwms-wms/wms/alcntc/${payload.uuid}/audit?version=${payload.version}`, {
    method: 'POST'
  });
}

export async function finish(payload) {
  return request(`/iwms-wms/wms/alcntc/complete?uuid=${payload.uuid}&version=${payload.version}`, {
    method: 'POST'
  });
}

export async function abort(payload) {
  return request(`/iwms-wms/wms/alcntc/abort?uuid=${payload.uuid}&version=${payload.version}`, {
    method: 'POST'
  });
}

export async function getWaveAlcNtcBills(params) {
  return request(`/iwms-wms/wms/alcntc/getWaveAlcNtcBill`, {
    method: 'POST',
    body: params,
  });
}
export async function batchImport(payload) {
  return request(`/iwms-wms/wms/alcntc/batchimport?companyUuid=${loginCompany().uuid}&dcUuid=${loginOrg().uuid}&fileKey=${payload.fileKey}`, {
    method: 'POST'
  });
}
export async function copy(payload) {
  return request(`/iwms-wms/wms/alcntc/cpAndSave?${stringify(payload)}`,{
    method: 'POST'
  });
}
export async function getByNumber(payload) {
  let dcUuid = payload.dcUuid ? payload.dcUuid : loginOrg().uuid;
  return request(`/iwms-wms/wms/alcntc/${payload.billNumber}/get?dcUuid=${dcUuid}`);
}
export async function initialModifyQty(payload) {
  return request(`/iwms-wms/wms/alcntc/${payload.uuid}/modifyqty?version=${payload.version}`, {
    method: 'POST',
    body: payload.items,
  });
}
export async function modifyCarrier(payload) {
  return request(`/iwms-wms/wms/alcntc/modifyCarrier?newCarrierUuid=${payload.newCarrierUuid}&uuid=${payload.uuid}&version=${payload.version}`, {
    method: 'POST',
    body: payload.filter
  })
}

export async function getRealQtyByBillNumber(payload) {
  let dcUuid = payload.dcUuid ? payload.dcUuid : loginOrg().uuid;
  return request(`/iwms-wms/wms/alcntc/${payload.billNumber}/getRealQtyByBillNumber?dcUuid=${dcUuid}`);
}
